import { breakpoints, Link, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { REVIEW_SLIDE_DESKTOP_HEIGHT } from '../Gallery/styled';

export const ContentWrapper = styled.div`
  padding: 20px 20px 32px;

  @media (min-width: ${breakpoints.md}) {
    width: 50%;
    padding: 48px 24px 32px 40px;
    overflow-y: auto;
    height: ${REVIEW_SLIDE_DESKTOP_HEIGHT}px;
  }
`;

export const MoreInfoLink = styled(Link)`
  margin-left: 0.25rem;
  text-decoration: underline;
`;

export const TooltipContent = styled.div`
  max-width: max-content;
  width: 15rem;
  padding: 0.5rem;
`;

export const SecondaryText = styled.div`
  ${theme.typography.labelSmall400}
  color: ${theme.color.text.secondary};

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.labelRegular400}
  }
`;

export const ReviewStats = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;
`;

export const Username = styled.div`
  ${theme.typography.labelSmall}

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.labelRegular}
  }
`;

export const TitleText = styled.div`
  ${theme.typography.labelLarge}
  color: ${theme.color.text.primary};

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleSmall}
    font-size: 18px;
    margin-bottom: 0.75rem;
  }
`;

export const ReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 24px;
`;

export const TitleAndVariantAndTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    gap: 0.75rem;
  }
`;

export const ReviewText = styled.div`
  ${theme.typography.bodyRegular}

  width: 100%;
  word-break: break-word;

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.bodyLarge}
  }
`;

export const ThumbsUpDownWrapper = styled.div`
  margin-left: 1rem;
  display: flex;
  gap: 0.75rem;

  svg {
    color: ${theme.color.icon.secondary};
    width: 14px;
    height: 14px;
  }

  @media (min-width: ${breakpoints.md}) {
    svg {
      width: 16px;
      height: 16px;
    }
  }

  > button {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: flex;
    gap: 0.25rem;
    align-items: center;
    user-select: none;
  }
`;

export const IconsWrapper = styled.div`
  svg {
    vertical-align: initial !important;
  }
`;
